<script setup lang="ts">
import StackLayout from '@/components/Layouts/StackLayout.vue'
import { DetectionTypography, TypographyItem } from '@/components/Typography'
import type { DetectionModel } from '@/types/models/DetectionModel'

type Props = {
    detections: DetectionModel[]
}
defineProps<Props>()
</script>

<template>
    <StackLayout v-bind="$attrs">
        <StackLayout direction="column" :gap="4">
            <TypographyItem v-if="detections?.length" :label="$t('device.latestDetections')" />
            <span v-else class="no-detection">{{ $t('device.noDetectionFound') }}</span>
            <DetectionTypography
                v-for="(detection, key) in detections"
                :index="key"
                :key="key"
                v-bind="detection" />
        </StackLayout>
    </StackLayout>
</template>
